<template>
    <div class="report-container">
        <div class="title">
            <h1 class="mt-4">Reports</h1>
        </div>
  
        <div class="report-loader" v-if="loading"></div>
  
        <div class="container mt-5">
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label for="report">Report Name</label>
                        <select @change="loadInputBasedOnReport($event)" class="form-control" id="report">
                            <option disabled value="">Select Report</option>
                            <option v-if="this.report1Flag" value="1">Employee Report</option>
                            <option v-if="this.report2Flag" value="2">Leave Tracker Report(AL and SL only)</option>
                            <option v-if="this.report3Flag" value="3">Leave Balance Report(All)</option>
                            <option v-if="this.report1Flag" value="4">Leave – Annual Leave - Department Wise</option>
                            <option v-if="this.report1Flag" value="5">Leave – Sick Leave – Department Wise</option>
                            <option v-if="this.report1Flag" value="6">New Employees – Per month</option>
                            <option v-if="this.report1Flag" value="7">Resignations – Per month</option>
                            <option v-if="this.report1Flag" value="8">Employee Exit – Per month</option>
                            <option v-if="this.report1Flag" value="9">Terminations – Per month</option>
                            <option v-if="this.report1Flag" value="10">Logins – Per month</option>
                            <option v-for="(report, index) in reports" :key="`custom-report-${index}`"
                                :value="report.url" @click="selectReport(report.url)">
                                {{ report.name }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
  
        <div class="container report-form">
            <div class="row">
  
                <div v-if="reportType == '1' || reportType == '4' || reportType == '5' || reportType == '' || reportType == '6' || reportType == '7' || reportType == '8' || reportType == '9' || reportType == '10'"
                    class="col-md-6">
                    <div class="form-group">
                        <label for="start_Date">Start Date<span class="required">*</span></label>
                        <input class="form-control" id="start_Date" type="date" placeholder="Enter Start Date"
                            v-model="reportsData.startDate" @change="handleDate(reportsData.startDate)">
                    </div>
                </div>
  
                <div v-if="reportType == '1' || reportType == '4' || reportType == '5' || reportType == '' || reportType == '6' || reportType == '7' || reportType == '8' || reportType == '9' || reportType == '10'"
                    class="col-md-6">
                    <div class="form-group">
                        <label for="end_Date">End Date<span class="required">*</span></label>
                        <input class="form-control" id="end_Date" min="" type="date" placeholder="Enter End Date"
                            v-model="reportsData.endDate">
                    </div>
                </div>
  
                <div v-if="reportType == '1' || reportType == ''" class="col-md-6">
                    <div class="form-group">
                        <label for="status">Employee Status<span class="required">*</span></label>
                        <select2-multiple-control id="status" v-model="reportsData.status" :options="statusOptions"
                            @change="myChangeEvent($event, type[0])" />
                    </div>
                </div>
  
                <div v-if="reportType == '1' || reportType == '4' || reportType == '5' || reportType == '' || reportType == '6' || reportType == '7' || reportType == '8' || reportType == '9' || reportType == '10'"
                    class="col-md-6">
                    <div class="form-group">
                        <label for="Department">Department<span class="required">*</span></label>
                        <select2-multiple-control v-model="reportsData.department" :options="departmentOptions"
                            @change="myChangeEvent($event, type[1])" />
                    </div>
                </div>
                <div v-if="reportType == '1' || reportType == ''" class="col-md-6">
                    <div class="form-group">
                        <label for="country">Location<span class="required">*</span></label>
                        <select2-multiple-control class="mySelect" v-model="reportsData.country"
                            :options="const_country" @change="myChangeEvent($event, type[2])" />
                    </div>
                </div>
  
                <!-- <div class="col-md-6">
          <div class="form-group">
            <label for="country">Employee Type<span class="required">*</span></label>
            <select class="form-control" id="type" v-model="reportsData.employeeType"  @change="myChangeEvent(reportsData.employeeType,type[3])">
                    <option v-for="(option,index) in employeeType" :key="index" :value="option">{{ option }}</option>
                </select>
          </div>
        </div> -->
  
                <div v-if="reportType == '1' || reportType == ''" class="col-md-6">
                    <div class="form-group">
                        <label for="country">Employee Type<span class="required">*</span></label>
                        <select2-multiple-control class="mySelect" v-model="reportsData.employeeType"
                            :options="typeOptions" @change="myChangeEvent($event, type[3])" />
                    </div>
                </div>
            </div>
  
            <div v-if="reportType == '1' || reportType == '' || reportType == '4' || reportType == '5' || reportType == '6' || reportType == '7' || reportType == '8' || reportType == '9' || reportType == '10'"
                class="container">
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <input class="radio-btn mr-2" id="PDF" value="pdf" type="radio" v-model="fileFormat">
                            <label for="PDF">PDF</label>
                        </div>
                    </div>
  
                    <div class="col-md-4">
                        <div class="form-group">
                            <input class="radio-btn mr-2" id="CSV" value="csv" type="radio" v-model="fileFormat">
                            <label for="CSV">CSV</label>
                        </div>
                    </div>
  
                    <div class="col-md-4">
                        <div class="form-group">
                            <input class="radio-btn mr-2" id="Excel" value="xlsx" type="radio" v-model="fileFormat">
                            <label for="Excel">Excel</label>
                        </div>
                    </div>
                </div>
            </div>
  
            <div class="container mt-5" v-if="!isCustomReportSelected">
                <div class="row">
                    <div class="col-md-3">
                        <button type="submit" class="btn btn-primary" :disabled="isDisabled"
                            @click="validateAndDownloadReports">Download Reports</button>
                    </div>
                    <div v-if="reportType == '4' || reportType == '5' || reportType == '6' || reportType == '7' || reportType == '8' || reportType == '9' || reportType == '10'"
                        class="col-md-3">
                        <button type="submit" class="btn btn-primary" :disabled="isDisabled"
                            @click="graphicalReports">Graphical Reports</button>
                    </div>
                </div>
            </div>
        </div>
        <div>
      <!-- Section with Add Report and Delete Report icons and text -->
      <div style="position: absolute; top: 140px; right: 160px; display:flex;" v-if="role_Id == 1">
          <div class="icon-container" @click="toggleModal" title="Add New Report">
              <i class="bi bi-plus-circle add-report-icon"></i>
              <span class="icon-text">Add Report</span>
          </div>
          <div class="icon-container" @click="toggleEditModal" title="Delete Reports">
              <i class="bi bi-trash delete-report-icon"></i>
              <span class="icon-text">Delete Report</span>
          </div>
  
          <!-- Modal for Adding Report -->
          <div v-if="showModal" class="modal-overlay" @click.self="toggleModal">
              <div class="modal-content">
                  <h2>Add New Report</h2>
                  <form @submit.prevent="addReport">
                      <div class="form-group">
                          <label for="reportName">Report Name:</label>
                          <input v-model="reportName" type="text" id="reportName" placeholder="Enter report name"
                              class="form-control">
                      </div>
                      <div class="form-group">
                          <label for="reportUrl">Report URL:</label>
                          <input v-model="reportUrl" type="text" id="reportUrl" placeholder="Enter report URL"
                              class="form-control">
                      </div>
                      <div class="form-group">
                          <label for="roleSelect">Roles:</label>
                          <select v-model="selectedRoleIds" id="roleSelect" class="form-control" multiple>
                              <option v-for="role in getRoles" :key="role.id" :value="role.id">{{ role.name }}</option>
                          </select>
                      </div>
                      <div class="modal-buttons">
                          <button type="submit" class="btn btn-primary">Add Report</button>
                          <button type="button" class="btn btn-secondary" @click="clearFields">Clear</button>
                          <button type="button" class="btn btn-secondary" @click="toggleModal">Close</button>
                      </div>
                  </form>
              </div>
          </div>
  
          <!-- Modal for Editing/Deleting Reports -->
          <div v-if="showEditModal" class="modal-overlay" @click.self="toggleEditModal">
              <div class="modal-content">
                  <h2>Edit/Delete Reports</h2>
                  <div v-for="(report, index) in reports" :key="`edit-report-${index}`" class="report-item">
                      <span>{{ report.name }}</span>
                      <div class="modal-buttons">
                          <i class="bi bi-pencil edit-icon" @click="editReport(index)" title="Edit Report"></i>
                          <i class="bi bi-trash delete-icon" @click="deleteReport(index)" title="Delete Report"></i>
                      </div>
                  </div>
                  <div class="modal-buttons">
                      <button class="btn btn-secondary" @click="toggleEditModal">Close</button>
                  </div>
              </div>
          </div>
  
          <!-- Modal for Editing a Report -->
          <div v-if="showEditReportModal" class="modal-overlay" @click.self="toggleEditReportModal">
              <div class="modal-content">
                  <h2>Edit Report</h2>
                  <form @submit.prevent="updateReport">
                      <div class="form-group">
                          <label for="editReportName">Report Name:</label>
                          <input v-model="editReportName" type="text" id="editReportName"
                              placeholder="Enter report name" class="form-control">
                      </div>
                      <div class="form-group">
                          <label for="editReportUrl">Report URL:</label>
                          <input v-model="editReportUrl" type="text" id="editReportUrl"
                              placeholder="Enter report URL" class="form-control">
                      </div>
                      <div class="form-group">
                          <label for="editRoleSelect">Roles:</label>
                          <select v-model="editSelectedRoleIds" id="editRoleSelect" class="form-control" multiple>
                              <option v-for="role in getRoles" :key="role.id" :value="role.id">{{ role.name }}</option>
                          </select>
                      </div>
                      <div class="modal-buttons">
                          <button type="submit" class="btn btn-primary">Save Changes</button>
                          <button type="button" class="btn btn-secondary" @click="toggleEditReportModal">Cancel</button>
                      </div>
                  </form>
              </div>
          </div>
      </div>
  
      <!-- Display selected report -->
      <div v-if="selectedReport" class="report-iframe">
          <iframe style="width:97%" :src="selectedReport" width="600" height="800"></iframe>
      </div>
  </div>
  
  
  
  
  
    </div>
    <div class="graphical-report-container" v-if="graphicalEnable">
        <div class="graphical-report-background" @click="closeOverlay"></div>
        <div class="graphical-report-canvas">
            <button @click="export_pdf" class="export-button"> Export as PDF</button>
            <div style="height: 300px; margin:0% 5% 0% 5%">
                <div style="width:100%;height:auto;">
                    <canvas id="bar" ref="myChart_bar">
                    </canvas>
                </div>
            </div>
            <div style="margin:2% 5% 5% 5%; padding-bottom: 20px;">
                <div style="width:auto;">
                    <canvas id="line" ref="myChart_line" style="height: 100px; width: auto;">
                    </canvas>
                </div>
            </div>
  
        </div>
    </div>
  
  
  
  </template>
  
  <script>
  import axios from 'axios';
  import moment from 'moment';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import 'sweetalert2/src/sweetalert2.scss';
  import Select2MultipleControl from 'v-select2-multiple-component';
  // import $ from 'jquery';
  import {
    decryptData
  } from '../js/utils/encrypt';
  import Exporter from 'vue-chartjs-exporter';
  import {
    Chart
  } from 'chart.js';
  
  export default {
    components: {
        Select2MultipleControl
    },
    data() {
        return {
            loading: false,
            isDisabled: false,
            fileFormat: 'pdf',
            reportsData: {
                startDate: '',
                endDate: '',
                status: [],
                department: [],
                country_and_city: [],
                employeeType: []
            },
            employeeStatus: {},
            employeeType: {},
            departments: {},
            country: {},
            departmentOptions: [],
            statusOptions: [],
            typeOptions: [],
            countryOptions: [],
            cityOptions: [],
            type: ['status', 'department', 'country', 'emptype'],
            // employeeType: ['All','Full Time Employee','Full Time Consultant','Part Time Consultant'],
            const_country: ['All', 'Bangalore - India', 'Delhi - India', 'Mumbai - India',
                'Canberra - Australia', 'Sydney - Australia', 'Singapore', 'China', 'Hong Kong', 'Japan', 'Malaysia', 'Philippines'
            ],
            empType: [],
            reportType: '',
            report1Flag: false,
            report2Flag: false,
            report3Flag: false,
            graphicalEnable: false,
            reports: [],
            showModal: false,
            showEditModal: false,
            showEditReportModal: false,
            reportName: '',
            reportUrl: '',
            editReportName: '',
            editReportUrl: '',
            selectedRoleIds: [],
            editSelectedRoleIds: [],
            selectedReport: '',
            editingReportIndex: null,
            getRoles: [],
            role_id: '',
            role_Id: null,
        };
    },
    created() {
        this.fetchReports();
        this.fetchRoles()
    },
    computed: {
        isCustomReportSelected() {
            // Check if reports is an array before calling .some()
            return Array.isArray(this.reports) && this.reports.some(report => report.url === this.selectedReport);
        }
    },
  
    async mounted() {
        //Decrypting Permissions
        let mkLocalData = localStorage.getItem('Permissions');
        if (!mkLocalData) {
            mkLocalData = 'null';
        }
        const secretPermissionKey = process.env.KEY || 'myscecretkey';
        this.permissions = decryptData(mkLocalData, secretPermissionKey);
        // console.log('this is the permissiondycripted data', this.permissions);
  
        this.loadReportsByPermission();
  
        this.loading = true;
        let department = [];
        let status = [];
        let type = [];
  
        let currentDate = new Date();
        this.reportsData.startDate = currentDate.getFullYear() + '-' + `${currentDate.getMonth() + 1}` + '-' + currentDate.getDate();
        this.reportsData.endDate = this.reportsData.startDate;
  
        document.getElementById('end_Date').min = this.reportsData.startDate;
  
        this.reportsData.startDate = "";
        this.reportsData.endDate = "";
  
        const all = ['All'];
        await axios.get(this.$hostName + '/getAllDepertments').then((response) => {
            this.departments = response.data;
            for (let i = 0; i < this.departments.length; i++) {
                department.push(this.departments[i].deparment);
            }
            this.departmentOptions = [...all, ...department];
            // this.reportsData.department.push(this.departmentOptions);
        }).catch((error) => {
            console.log(error);
        });
  
        await axios.get(this.$hostName + '/getAllStatus').then((response) => {
            this.employeeStatus = response.data;
            for (let i = 0; i < this.employeeStatus.length; i++) {
                status.push(this.employeeStatus[i].status);
            }
            this.statusOptions = [...all, ...status];
            // this.reportsData.status.push(this.statusOptions);
        }).catch((error) => {
            console.log(error);
        }).finally(() => {
            this.loading = false;
        });
  
        await axios.get(this.$hostName + '/getAllEmploymentTypes').then((response) => {
            this.employeeType = response.data;
            for (let i = 0; i < this.employeeType.length; i++) {
                type.push(this.employeeType[i].type);
            }
            this.typeOptions = [...all, ...type];
            // this.reportsData.employeeType.push(this.typeOptions);
        }).catch((error) => {
            console.log(error);
        }).finally(() => {
            this.loading = false;
        });
    },
    methods: {
  
        export_pdf() {
            let bar = document.getElementById('bar');
            let line = document.getElementById('line');
            const fileName = this.getReportFileName(); // Get the report name
            const exp = new Exporter([bar, line]);
            exp.export_pdf().then((pdf) => pdf.save(fileName + '.pdf'));
        },
        toggleModal() {
            this.showModal = !this.showModal;
        },
        toggleEditModal() {
            this.showEditModal = !this.showEditModal;
        },
        toggleEditReportModal() {
            this.showEditReportModal = !this.showEditReportModal;
        },
        async fetchReports() {
            try {
                let mkRoleData = localStorage.getItem('Role_Id');
                if (!mkRoleData) {
                    mkRoleData = 'null';
                }
                const secretRoleKey = process.env.KEY || 'myscecretkey';
                const decryptedRoleData = decryptData(mkRoleData, secretRoleKey);
                this.role_Id = decryptedRoleData;
  
                const response = await axios.get(`${this.$hostName}/reports`, { params: { role_id: this.role_Id } });
  
                // Check if response data is an object
                if (typeof response.data === 'object' && !Array.isArray(response.data)) {
                    // Convert object to array
                    this.reports = Object.values(response.data);
                } else if (Array.isArray(response.data)) {
                    // If it's already an array, use it directly
                    this.reports = response.data;
                } else {
                    console.error("Unexpected data format:", response.data);
                    this.reports = []; // Default to empty array
                }
  
                // console.log('Reports:', this.reports);
            } catch (error) {
                console.error("Error fetching reports:", error);
            }
        },
  
  
        async addReport() {
            try {
                if (this.reportName.trim() && this.reportUrl.trim() && this.selectedRoleIds.length) {
                    await axios.post(this.$hostName + '/reports', {
                        name: this.reportName,
                        url: this.reportUrl,
                        role_ids: this.selectedRoleIds
                    });
                    // console.log("Report added successfully:", response.data);
                    this.clearFields();
                    this.toggleModal();
                    this.fetchReports();
  
                    // Show success alert with SweetAlert2
                    Swal.fire({
                        icon: 'success',
                        title: 'Success!',
                        text: 'Report added successfully',
                        confirmButtonText: 'OK'
                    });
                } else {
                    // Show warning alert with SweetAlert2
                    Swal.fire({
                        icon: 'warning',
                        title: 'Missing Fields',
                        text: 'Please fill in all related fields',
                        confirmButtonText: 'OK'
                    });
                }
            } catch (error) {
                console.error("Error adding report:", error);
            }
        },
        editReport(index) {
            const report = this.reports[index];
            this.editingReportIndex = index;
            this.editReportName = report.name;
            this.editReportUrl = report.url;
            this.editSelectedRoleIds = JSON.parse(report.role_ids || "[]");
            this.toggleEditReportModal();
        },
        async updateReport() {
            try {
                if (this.editReportName.trim() && this.editReportUrl.trim() && this.editSelectedRoleIds.length) {
                    const reportId = this.reports[this.editingReportIndex].id;
                    await axios.put(this.$hostName + `/reports/${reportId}`, {
                        name: this.editReportName,
                        url: this.editReportUrl,
                        role_ids: this.editSelectedRoleIds
                    });
                    this.fetchReports();
                    this.toggleEditReportModal();
                    Swal.fire({
                  icon: 'success',
                  title: 'Success!',
                  text: 'Your changes have been saved',
                  confirmButtonText: 'OK'
              });
                } else {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Missing Fields',
                        text: 'Please fill in all related fields',
                        confirmButtonText: 'OK'
                    });
                }
            } catch (error) {
                console.error("Error updating report:", error);
            }
        },
        async deleteReport(index) {
            try {
                const reportId = this.reports[index].id;
                await axios.delete(`${this.$hostName}/reports/${reportId}`);
  
                // Remove the report from the local list
                const deletedReportUrl = this.reports[index].url;
                this.reports.splice(index, 1);
  
                // If the deleted report was the currently selected report, clear the iframe
                if (this.selectedReport === deletedReportUrl) {
                    this.selectedReport = ''; // Clear the iframe
                }
  
                // Check if the selectedReport is still valid
                const reportExists = this.reports.some(report => report.url === this.selectedReport);
                if (!reportExists) {
                    this.selectedReport = '';
                }
  
                // Show success alert with SweetAlert2
                Swal.fire({
                    icon: 'success',
                    title: 'Deleted!',
                    text: 'Report deleted successfully',
                    confirmButtonText: 'OK'
                });
            } catch (error) {
                console.error("Error deleting report:", error);
            }
        },
        async fetchRoles() {
            try {
                const response = await axios.get(this.$hostName + '/getAllRoles');
                this.getRoles = response.data.roles;
                // console.log("Roles:", this.getRoles);
            } catch (error) {
                console.error("Error fetching roles:", error);
            }
        },
        selectReport(reportUrl) {
            this.selectedReport = reportUrl;
        },
        clearFields() {
            this.reportName = '';
            this.reportUrl = '';
            this.selectedRoleIds = [];
        },
        getReportFileName() {
            if (this.reportType == '4') {
                return 'Annualleave_Employee_Report_Chart_' + moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
            } else if (this.reportType == '5') {
                return 'Sickleave_Employee_Report_Chart_' + moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
            } else if (this.reportType == '6') {
                return 'New_Employee_Report_Chart_' + moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
            } else if (this.reportType == '7') {
                return 'Resigned_Employee_Report_Chart_' + moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
            } else if (this.reportType == '8') {
                return 'Employee_Exit_Report_Chart_' + moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
            } else if (this.reportType == '9') {
                return 'Terminated_Employee_Report_Chart_' + moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
            } else if (this.reportType == '10') {
                return "Logins_Report_Chart_" + moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
            }
        },
  
        closeOverlay() {
            this.graphicalEnable = false;
        },
        graphicalReports() {
            var chartData = '';
            var departments = this.reportsData.department;
            var heading = '';
  
            if (this.reportsData.startDate == "" || this.reportsData.endDate == "" || departments.length == 0) {
                Swal.fire({
                    text: "Kindly select the required fields",
                    confirmButtonText: "Ok"
                });
            } else {
                this.graphicalEnable = true;
  
                // const fromDate = moment(this.reportsData.startDate).format('YYYY-MM-DD');
                // const toDate = moment(this.reportsData.endDate).format('YYYY-MM-DD');
                // console.log('Start date:', fromDate, toDate);
                // console.log('dept:', departments)
                if (this.reportType == '4') {
                    heading = 'Leave Details By Departments';
                    axios.post(this.$hostName + '/testReport', {
                        start_date: this.reportsData.startDate,
                        end_date: this.reportsData.endDate,
                        leave_type: 'Annual Leave',
                        departments: departments
                    }).then(response => {
                        console.log(response);
                        chartData = response.data;
                        this.generateChart(chartData, heading);
                    });
                } else if (this.reportType == '5') {
                    heading = 'Leave Details By Departments';
                    axios.post(this.$hostName + '/testReport', {
                        start_date: this.reportsData.startDate,
                        end_date: this.reportsData.endDate,
                        leave_type: 'Sick Leave',
                        departments: departments
                    }).then(response => {
                        console.log(response);
                        chartData = response.data;
                        this.generateChart(chartData, heading);
                    });
                } else if (this.reportType == '6') {
                    heading = 'New Employee By Departments';
                    console.log(this.reportsData.startDate, this.reportsData.endDate);
                    axios.post(this.$hostName + '/newemp', {
                        start_date: this.reportsData.startDate,
                        end_date: this.reportsData.endDate,
                        departments: departments
                    }).then(response => {
                        console.log(response.data);
                        // console.log(start_date, end_date);
                        chartData = response.data;
                        this.generateChart(chartData, heading);
                    });
                } else if (this.reportType == '7') {
                    heading = 'Employee Resignations – Per month';
                    axios.post(this.$hostName + '/empResignation', {
                        start_date: this.reportsData.startDate,
                        end_date: this.reportsData.endDate,
                        departments: departments
                    }).then(response => {
                        console.log(response);
                        chartData = response.data;
                        this.generateChart(chartData, heading);
                    });
                } else if (this.reportType == '8') {
                    heading = 'Employee Exit – Per month';
                    axios.post(this.$hostName + '/empExit', {
                        start_date: this.reportsData.startDate,
                        end_date: this.reportsData.endDate,
                        departments: departments
                    }).then(response => {
                        console.log(response);
                        chartData = response.data;
                        this.generateChart(chartData, heading);
                    });
                } else if (this.reportType == '9') {
                    heading = 'Employees Termination – Per month';
                    axios.post(this.$hostName + '/empTermination', {
                        start_date: this.reportsData.startDate,
                        end_date: this.reportsData.endDate,
                        departments: departments
                    }).then(response => {
                        console.log(response);
                        chartData = response.data;
                        this.generateChart(chartData, heading);
                    });
                } else if (this.reportType == "10") {
                    heading = "Logins Per Month";
                    axios
                        .post(this.$hostName + "/loginsReport", {
                            start_date: this.reportsData.startDate,
                            end_date: this.reportsData.endDate,
                            departments: departments,
                        })
                        .then((response) => {
                            console.log(response);
                            chartData = response.data;
                            this.generateChart(chartData, heading);
                        });
                }
            }
        },
        generateChart(chartData, heading) {
            new Chart(this.$refs.myChart_bar, {
                type: 'bar',
                data: chartData.bar,
                options: {
                    responsive: true,
                    devicePixelRatio: 1.5,
                    // legend: {
                    //     display: false
                    // },
                    scales: {
                        yAxes: [{
                            display: true,
                            ticks: {
                                beginAtZero: true,
                                // steps: 10,
                                stepValue: 1,
                                // max: 10
                            }
                        }]
                    },
                    title: {
                        display: true,
                        text: heading
                    }
                }
            });
            new Chart(this.$refs.myChart_line, {
                type: 'line',
                data: chartData.line,
                options: {
                    responsive: true,
                    devicePixelRatio: 1.5,
                    legend: {
                        display: false
                    },
                    scales: {
                        yAxes: [{
                            display: true,
                            ticks: {
                                beginAtZero: true,
                                // steps: 10,
                                stepValue: 1,
                                // max: 10
                            }
                        }]
                    },
                    title: {
                        display: false,
                        text: heading
                    }
                }
            });
  
            let canvas2 = document.getElementById('line');
            // let canvas1 = document.getElementById('bar');
            canvas2.style.height = "280px";
            // canvas1.style.height = "350px";
            // canvas1.resize();
            canvas2.resize();
  
        },
        loadReportsByPermission() {
            if (this.permissions.includes('Leave-Balance-Report(All)')) {
                this.report3Flag = true;
                this.reportType = '3';
            }
            if (this.permissions.includes('Leave-Tracker-Report(AL and SL only)')) {
                this.report2Flag = true;
                this.reportType = '2';
            }
            if (this.permissions.includes('Employee-Report')) {
                this.report1Flag = true;
                this.reportType = '1';
            }
        },
        handleDate(val) {
            document.getElementById('end_Date').min = val;
        },
        myChangeEvent(val, type) {
            if (type == 'status' && val[0] == 'All') {
                this.reportsData.status = this.statusOptions;
            } else if (type == 'status') {
                this.reportsData.status = val;
            } else if (type == 'department' && val[0] == 'All') {
                this.reportsData.department = this.departmentOptions.slice(1);
            } else if (type == 'department') {
                this.reportsData.department = val;
            } else if (type == 'emptype' && val == 'All') {
                this.reportsData.employeeType = ['All', 'Full Time Employee', 'Full Time Consultant', 'Part Time Consultant'];
            } else if (type == 'emptype') {
                this.reportsData.employeeType = val;
            } else if (type == 'country' && val[0] == 'All') {
                this.reportsData.country_and_city = this.const_country;
            } else {
                this.reportsData.country_and_city = val;
            }
        },
        loadInputBasedOnReport(event) {
            const selectedValue = event.target.value;
            this.reportType = selectedValue;
  
            // Ensure reports is an array
            if (Array.isArray(this.reports)) {
                const customReport = this.reports.find(report => report.url === selectedValue);
                if (customReport) {
                    this.selectedReport = customReport.url;
                } else {
                    this.selectedReport = '';
                }
            } else {
                console.error('Reports is not an array:', this.reports);
            }
        },
        downloadReports() {
            const fileType = this.fileFormat;
            if (this.reportType == '') {
                Swal.fire({
                    text: 'Kindly select a report to generate',
                    confirmButtonText: 'Ok',
                });
            } else if (this.reportType == '1') {
                const fromDate = moment(this.reportsData.startDate).format('YYYY-MM-DD');
                const toDate = moment(this.reportsData.endDate).format('YYYY-MM-DD');
  
                var formData = {
                    fDate: fromDate,
                    tDate: toDate,
                    status: this.reportsData.status,
                    country_city: this.reportsData.country_and_city,
                    department: this.reportsData.department,
                    empType: this.reportsData.employeeType,
                    rName: 'Employee List',
                    rType: 'employee',
                    fType: fileType,
                };
                if (formData.fDate == 'Invalid date' || formData.tDate == 'Invalid date' || formData.status.length == 0 || formData.country_city.length == 0 || formData.department.length == 0 || formData.empType == '') {
                    Swal.fire({
                        text: 'Kindly select the required fields.',
                        confirmButtonText: 'Ok',
                    });
                } else {
                    axios({
                        url: this.$hostName + '/downloadReport',
                        method: 'POST',
                        responseType: 'blob',
                        data: formData,
                    }).then((response) => {
                        const binaryResponse = new Blob([response.data]);
                        if (binaryResponse.size > 10) {
                            var fileURL = window.URL.createObjectURL(binaryResponse);
                            var fileLink = document.createElement('a');
                            fileLink.href = fileURL;
                            var fileName =
                                'Employee' +
                                moment(new Date()).format('YYYY-MM-DD HH:mm:ss') +
                                '.' +
                                fileType;
                            fileLink.setAttribute('download', fileName);
                            document.body.appendChild(fileLink);
                            fileLink.click();
                            fileLink.remove();
                        } else {
                            Swal.fire({
                                text: 'No data for the selected filter criteria',
                                confirmButtonText: 'Ok',
                            });
                        }
                    });
                }
            } else if (this.reportType == '4') {
                const formDataForNewReport = {
                    rType: 'empLeaveReport', // Set the report type to 'Annual leave'
                    fType: fileType,
                    leave_type: 'Annual Leave',
                    report_title: 'Annual Leave Details',
                    start_date: this.reportsData.startDate, // Add start date to the form data
                    end_date: this.reportsData.endDate, // Add end date to the form data
                    departments: this.reportsData.department, // Add department to the form data
                };
  
                this.loading = true;
                axios({
                    url: this.$hostName + '/downloadReport',
                    method: 'POST',
                    responseType: 'blob',
                    data: formDataForNewReport,
                })
                    .then((response) => {
                        const binaryResponse = new Blob([response.data]);
                        if (binaryResponse.size > 10) {
                            const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                            const fileLink = document.createElement('a');
                            fileLink.href = fileURL;
                            const fileName = 'Annualleave_Employee_Report' + moment(new Date()).format('YYYY-MM-DD HH:mm:ss') + '.' + fileType;
                            fileLink.setAttribute('download', fileName);
                            document.body.appendChild(fileLink);
                            fileLink.click();
                            fileLink.remove();
                        } else {
                            Swal.fire({
                                text: 'No data for the selected filter criteria',
                                confirmButtonText: 'Ok',
                            });
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            } else if (this.reportType == '5') {
                const formDataForNewReport = {
                    rType: 'empLeaveReport', // Set the report type to 'Annual leave'
                    fType: fileType,
                    leave_type: 'Sick Leave',
                    report_title: 'Sick Leave Details',
                    start_date: this.reportsData.startDate, // Add start date to the form data
                    end_date: this.reportsData.endDate, // Add end date to the form data
                    departments: this.reportsData.department, // Add department to the form data
                };
  
                this.loading = true;
                axios({
                    url: this.$hostName + '/downloadReport',
                    method: 'POST',
                    responseType: 'blob',
                    data: formDataForNewReport,
                })
                    .then((response) => {
                        const binaryResponse = new Blob([response.data]);
                        if (binaryResponse.size > 10) {
                            const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                            const fileLink = document.createElement('a');
                            fileLink.href = fileURL;
                            const fileName = 'Sickleave_Employee_Report' + moment(new Date()).format('YYYY-MM-DD HH:mm:ss') + '.' + fileType;
                            fileLink.setAttribute('download', fileName);
                            document.body.appendChild(fileLink);
                            fileLink.click();
                            fileLink.remove();
                        } else {
                            Swal.fire({
                                text: 'No data for the selected filter criteria',
                                confirmButtonText: 'Ok',
                            });
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            } else if (this.reportType == '6') {
                const formDataForNewReport = {
                    rType: 'newEmpReport', // Set the report type to 'newEmpReport'
                    fType: fileType,
                    startDate: this.reportsData.startDate, // Add start date to the form data
                    endDate: this.reportsData.endDate, // Add end date to the form data
                    departments: this.reportsData.department, // Add department to the form data
                };
  
                this.loading = true;
                axios({
                    url: this.$hostName + '/downloadReport',
                    method: 'POST',
                    responseType: 'blob',
                    data: formDataForNewReport,
                })
                    .then((response) => {
                        const binaryResponse = new Blob([response.data]);
                        if (binaryResponse.size > 10) {
                            const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                            const fileLink = document.createElement('a');
                            fileLink.href = fileURL;
                            const fileName = 'New_Employee_Report_' + moment(new Date()).format('YYYY-MM-DD HH:mm:ss') + '.' + fileType;
                            fileLink.setAttribute('download', fileName);
                            document.body.appendChild(fileLink);
                            fileLink.click();
                            fileLink.remove();
                        } else {
                            Swal.fire({
                                text: 'No data for the selected filter criteria',
                                confirmButtonText: 'Ok',
                            });
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
  
            //Here my new employee code ends
  
            //Here my Resigned employee code starts
            else if (this.reportType == '7') {
                const formDataForNewReport = {
                    rType: 'empResignedReport', // Set the report type to 'newEmpReport'
                    fType: fileType,
                    startDate: this.reportsData.startDate, // Add start date to the form data
                    endDate: this.reportsData.endDate, // Add end date to the form data
                    departments: this.reportsData.department, // Add department to the form data
                };
  
                this.loading = true;
                axios({
                    url: this.$hostName + '/downloadReport',
                    method: 'POST',
                    responseType: 'blob',
                    data: formDataForNewReport,
                })
                    .then((response) => {
                        const binaryResponse = new Blob([response.data]);
                        if (binaryResponse.size > 10) {
                            const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                            const fileLink = document.createElement('a');
                            fileLink.href = fileURL;
                            const fileName = 'Resigned_Employee_Report_' + moment(new Date()).format('YYYY-MM-DD HH:mm:ss') + '.' + fileType;
                            fileLink.setAttribute('download', fileName);
                            document.body.appendChild(fileLink);
                            fileLink.click();
                            fileLink.remove();
                        } else {
                            Swal.fire({
                                text: 'No data for the selected filter criteria',
                                confirmButtonText: 'Ok',
                            });
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
  
            //Here my resigned employee code ends
  
            //Here my termination employee code starts
            else if (this.reportType == '9') {
                const formDataForNewReport = {
                    rType: 'empTerminationReport', // Set the report type to 'empTerminationReport'
                    fType: fileType,
                    startDate: this.reportsData.startDate, // Add start date to the form data
                    endDate: this.reportsData.endDate, // Add end date to the form data
                    departments: this.reportsData.department, // Add department to the form data
                };
  
                this.loading = true;
                axios({
                    url: this.$hostName + '/downloadReport',
                    method: 'POST',
                    responseType: 'blob',
                    data: formDataForNewReport,
                })
                    .then((response) => {
                        const binaryResponse = new Blob([response.data]);
                        if (binaryResponse.size > 10) {
                            const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                            const fileLink = document.createElement('a');
                            fileLink.href = fileURL;
                            const fileName = 'Terminated_Employee_Report_' + moment(new Date()).format('YYYY-MM-DD HH:mm:ss') + '.' + fileType;
                            fileLink.setAttribute('download', fileName);
                            document.body.appendChild(fileLink);
                            fileLink.click();
                            fileLink.remove();
                        } else {
                            Swal.fire({
                                text: 'No data for the selected filter criteria',
                                confirmButtonText: 'Ok',
                            });
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
  
            //Here my terminated employee code ends
            //Here my Exit employee detailed Report code starts
            else if (this.reportType == '8') {
                const formDataForNewReport = {
                    rType: 'exitEmpReport', // Set the report type to 'empTerminationReport'
                    fType: fileType,
                    startDate: this.reportsData.startDate, // Add start date to the form data
                    endDate: this.reportsData.endDate, // Add end date to the form data
                    departments: this.reportsData.department, // Add department to the form data
                };
  
                this.loading = true;
                axios({
                    url: this.$hostName + '/downloadReport',
                    method: 'POST',
                    responseType: 'blob',
                    data: formDataForNewReport,
                })
                    .then((response) => {
                        const binaryResponse = new Blob([response.data]);
                        if (binaryResponse.size > 10) {
                            const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                            const fileLink = document.createElement('a');
                            fileLink.href = fileURL;
                            const fileName = 'Employee_Exit_Report_' + moment(new Date()).format('YYYY-MM-DD HH:mm:ss') + '.' + fileType;
                            fileLink.setAttribute('download', fileName);
                            document.body.appendChild(fileLink);
                            fileLink.click();
                            fileLink.remove();
                        } else {
                            Swal.fire({
                                text: 'No data for the selected filter criteria',
                                confirmButtonText: 'Ok',
                            });
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });  //Here my exit employee code ends
  
            }
            else if (this.reportType === "10") {
                const formDataForLoginsReport = {
                    rType: "loginsreport",
                    fType: fileType,
                    startDate: this.reportsData.startDate,
                    endDate: this.reportsData.endDate,
                    departments: this.reportsData.department,
                };
  
                this.loading = true;
                axios({
                    url: this.$hostName + "/downloadReport",
                    method: "POST",
                    responseType: "blob",
                    data: formDataForLoginsReport,
                })
                    .then((response) => {
                        const binaryResponse = new Blob([response.data]);
                        if (binaryResponse.size > 10) {
                            const fileURL = URL.createObjectURL(binaryResponse);
                            const fileLink = document.createElement("a");
                            fileLink.setAttribute("href", fileURL);
                            const fileName =
                                "Logins_Report_" +
                                moment(new Date()).format("YYYY-MM-DD HH:mm:ss") +
                                "." +
                                fileType;
                            fileLink.setAttribute("download", fileName);
                            fileLink.click();
                        } else {
                            Swal.fire({
                                text: "No data for the selected filter criteria",
                                confirmButtonText: "Ok",
                            });
                        }
                    })
                    .catch((error) => console.error(error))
                    .finally(() => this.loading = false);
            }
  
            else {
                let reportType = '';
                let reportName = '';
                if (this.reportType == '2') {
                    reportType = 'leaveBalanceALSL';
                    reportName = 'Leave_Tracker_ALSL_';
                } else {
                    reportType = 'leaveBalanceAll';
                    reportName = 'Leave_Balance_All_';
                }
                var formDataForLeaveReport = {
                    rType: reportType,
                    fType: 'xlsx',
                };
                this.loading = true;
                axios({
                    url: this.$hostName + '/downloadReport',
                    method: 'POST',
                    responseType: 'blob',
                    data: formDataForLeaveReport,
                })
                    .then((response) => {
                        const binaryResponse = new Blob([response.data]);
                        if (binaryResponse.size > 10) {
                            var fileURL = window.URL.createObjectURL(binaryResponse);
                            var fileLink = document.createElement('a');
                            fileLink.href = fileURL;
                            var fileName =
                                reportName +
                                moment(new Date()).format('YYYY-MM-DD HH:mm:ss') +
                                '.xlsx';
                            fileLink.setAttribute('download', fileName);
                            document.body.appendChild(fileLink);
                            fileLink.click();
                            fileLink.remove();
                        } else {
                            Swal.fire({
                                text: 'No data for the selected filter criteria',
                                confirmButtonText: 'Ok',
                            });
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        validateAndDownloadReports() {
            var departments = this.reportsData.department;
            if (this.reportType != '2' && this.reportType != '3') {
                if (this.reportsData.startDate == "" || this.reportsData.endDate == "" || departments.length == 0) {
                    Swal.fire({
                        text: "Kindly select the required fields",
                        confirmButtonText: "Ok"
                    });
                } else { this.downloadReports() }
            } else {
                this.downloadReports();
            }
        }
    }
  };
  </script>
  
  <style scoped>
  .report-container {
    font-family: 'Montserrat';
    position: absolute;
    left: 60px;
    width: calc(100% - 60px);
  }
  
  .title {
    margin-left: 2%;
  }
  
  .report-form {
    margin-top: 2%;
  }
  
  .required {
    color: red;
  }
  
  .report-loader {
    position: fixed;
    top: 0px;
    left: 60px;
    width: calc(100% - 60px);
    height: 100%;
    background-color: #eceaea;
    background-image: url("../assets/loading.gif");
    background-size: 150px;
    background-repeat: no-repeat;
    background-position: calc(calc(50%) - 30px);
    z-index: 999;
  }
  
  .graphical-report-container {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .graphical-report-background {
    position: absolute;
    z-index: 1;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }
  
  .graphical-report-canvas {
    z-index: 3;
    background-color: white;
    width: 700px;
    overflow-y: scroll;
    height: 660px;
  }
  
  .export-button {
    font-family: 'Montserrat';
    font-size: 0.85em;
    width: 117px;
    position: relative;
    display: flex;
    border: none;
    /* left: 50%; */
    margin: 20px auto 0px;
    padding: 10px 10px;
    /* transform: translate(-50%, 20px); */
    border-radius: 5px;
    background-color: #007bff;
    color: white;
  }
  
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .modal-content {
    background-color: white;
    padding: 20px;
    border-radius: 5px;
    width: 400px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  
  .report-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 0;
  }
  
  .report-container {
    width: 100%;
    margin: auto;
  }
  
  .modal-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 10px;
  }
  .add-report-icon,
  .edit-delete-report-icon {
    font-size: 24px;
    color: #007bff;
    cursor: pointer;
    margin-right: 10px;
    transition: color 0.2s;
  }
  
  .add-report-icon:hover,
  .edit-delete-report-icon:hover {
    color: #0056b3;
  }
  
  .icon-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 20px;
      cursor: pointer;
  }
  
  .add-report-icon,
  .delete-report-icon {
      font-size: 30px;
      color: #007bff;
      margin-bottom: 5px;
      transition: color 0.2s;
  }
  
  .icon-text {
      font-size: 14px;
      color: #333;
      text-align: center;
  }
  
  
  .edit-icon,
  .delete-icon {
    font-size: 18px;
    color: #007bff;
    cursor: pointer;
    margin-right: 10px;
  }
  
  .edit-icon:hover {
    color: #0056b3;
  }
  
  .delete-icon {
    color: #dc3545;
  }
  
  .delete-icon:hover {
    color: #c82333;
  }
  
  .modal-content h2 {
    margin-bottom: 15px;
    font-size: 20px;
    text-align: center;
  }
  
  .form-group {
    margin-bottom: 15px;
  }
  
  .form-group label {
    display: block;
    font-weight: bold;
    margin-bottom: 5px;
  }
  
  .form-control {
    width: 100%;
    padding: 8px;
    box-sizing: border-box;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  
  .report-iframe {
    margin-top: 20px;
    border: 1px solid #ccc;
    border-radius: 5px;
    overflow: hidden;
  }
  
  
  /* Media queries for mobile responsiveness */
  @media (max-width: 768px) {
    .modal-content {
      width: 90%;
      max-width: 350px;
      left:30px;
    }
  
    .add-report-button,
    .edit-delete-report-button {
      width: 70%;
      font-size: 12px;
      padding: 8px 15px;
      position: relative;
      bottom: 120px;
      left: 90px;
    }
  
    .modal-buttons {
      flex-direction: column;
      gap: 5px;
    }
  
    .report-iframe {
      width: 100%;
      height: auto;
    }
  
  
  }
  </style>
  